import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { auth } from 'firebase';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { PhoneNumber } from 'src/app/models/auth/phone-number';
import { AllActionsUnion } from '../../../app.actions';
import {
  resetState,
  storeConfirmationResult,
  storeErrorMessage,
  storePhoneNumber,
  updateLoading,
} from './sign-up.actions';

// @TODO loading state を、shared/gui で共通化する #225
// https://github.com/toreta/skipr-sp/issues/225
// @TODO errorMessage を、shared/gui で共通化する #226
// https://github.com/toreta/skipr-sp/issues/226
export interface SignUpState {
  confirmationResult: auth.ConfirmationResult | null;
  phoneNumber: PhoneNumber;
  loading: boolean;
  errorMessage: string;
}

const initialState: SignUpState = {
  confirmationResult: null,
  phoneNumber: new PhoneNumber(''),
  loading: false,
  errorMessage: '',
};

export const featureName = 'signUpFeature';

export function signUpReducer(
  state_: SignUpState | undefined,
  action: AllActionsUnion,
): SignUpState {
  const reducer_ = createReducer<SignUpState>(
    initialState,
    on(
      storeConfirmationResult,
      (state, { payload }): SignUpState => {
        return { ...state, confirmationResult: payload };
      },
    ),
    on(
      storePhoneNumber,
      (state, { payload }): SignUpState => {
        return { ...state, phoneNumber: payload };
      },
    ),
    on(
      updateLoading,
      (state, { payload }): SignUpState => {
        return { ...state, loading: payload };
      },
    ),
    on(
      storeErrorMessage,
      (state, { payload }): SignUpState => {
        return { ...state, errorMessage: payload };
      },
    ),
    on(
      resetState,
      (): SignUpState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<SignUpState>(featureName);

export const getConfirmationResult = pipe(
  select(
    createSelector(
      getFeature,
      v => v.confirmationResult,
    ),
  ),
);

export const getPhoneNumber = pipe(
  select(
    createSelector(
      getFeature,
      v => v.phoneNumber,
    ),
  ),
  filter(v => v.hasValue()),
);

export const getLoading = pipe(
  select(
    createSelector(
      getFeature,
      v => v.loading,
    ),
  ),
  distinctUntilChanged(),
);

export const getErrorMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.errorMessage,
    ),
  ),
  distinctUntilChanged(),
);
